module.exports = __webpack_public_path__ + "static/media/blockup-vertical-compressed-rotated.baf7140a.png";